module.exports = __webpack_public_path__ + "static/media/dollhouse.9a05ac64.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/dollhouse.png
// module id = 92
// module chunks = 0